import PropTypes from 'prop-types';
import React from 'react';
import { getMarkup } from './util';

import './IncidentCard.css';

/**
 * Reformat an ISO-8601-formatted date string.
 *
 * @return {string} The date formatted with
 *   `Date.prototype.toLocaleDateString` and options so it appears in a format
 *   like "January 1, 2019".
 */
function formatDate(ds) {
  // Split the date components and convert to numbers.
  const [year, month, day] = ds.split('-').map(bit => parseInt(bit, 10));
  // Create a new Date object. Note that the months are zero indexed.
  const d = new Date(year, month - 1, day);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'America/Chicago',
  };
  return d.toLocaleDateString('en-US', options);
}

function getEscalationLabel(val) {
  if (val === true) {
    return 'Escalated after Taser use';
  }

  return null;
}


function getGenderLabel(val) {
  if (val === 'M') {
    return 'Male';
  }

  if (val === 'F') {
    return 'Female';
  }

  return null;
}


function getRaceLabel(val) {
  if (val === 'A') {
    return 'Asian';
  }

  if (val === 'B') {
    return 'Black';
  }

  if (val === 'W') {
    return 'White';
  }

  if (val === 'H') {
    return 'Hispanic';
  }

  if (val === 'N') {
    return 'Native American';
  }

  if (val === 'O') {
    return null;
  }

  return val;
}


function IncidentCard({ shooting }) {
  const headline = shooting.headline ? <p className="IncidentCard_Headline">{shooting.headline}</p> : null;
  const escalationLabel = getEscalationLabel(shooting.TASER_ESCALATE);
  const raceLabel = getRaceLabel(shooting.race);
  const ageLabel = shooting.age ? `${shooting.age} years old` : null;
  /* eslint-disable react/no-danger */
  const detail = (
    shooting.narrative
      ? <div className="IncidentCard_Detail" dangerouslySetInnerHTML={getMarkup(shooting.narrative)} />
      : <div className="IncidentCard_Detail">{shooting.TASER_DETAIL}</div>
  );
  /* eslint-enable react/no-danger */

  return (
    <div className="IncidentCard" id={`incident-${shooting.id}`}>
      <h3 className="IncidentCard_Name">{shooting.name}</h3>
      {headline}
      <ul>
        <li>{formatDate(shooting.date)}</li>
        <li>
          {shooting.city}
          ,&nbsp;
          {shooting.state}
        </li>
      </ul>
      <ul className="Labels">
        {ageLabel ? <li className="Label">{ageLabel}</li> : null}
        <li className="Label">{getGenderLabel(shooting.gender)}</li>
        {raceLabel ? <li className="Label">{raceLabel}</li> : null}
        {escalationLabel ? <li className="Label Label_taser">{escalationLabel}</li> : null}
        {shooting.taserModels ? <li className="Label Label_taser">{shooting.taserModels}</li> : null}
      </ul>
      {detail}
    </div>
  );
}


IncidentCard.propTypes = {
  shooting: PropTypes.shape({
    TASER_DETAIL: PropTypes.string,
    TASER_ESCALATE: PropTypes.bool,
    TASER_FAILED_TO_SUBDUE: PropTypes.bool,
    age: PropTypes.string,
    city: PropTypes.string,
    date: PropTypes.string,
    gender: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    race: PropTypes.string,
    state: PropTypes.string,
    year: PropTypes.number,
    taserModels: PropTypes.string,
  }).isRequired,
};

export default IncidentCard;
